import { Navigate } from 'react-router-dom'
import { getAccessToken } from '@/config/api/authStore'
import { isAuthDevBypass, isAuthEnforced } from '@/config/api/env'
import { isWhoamiAuthenticated, useWhoami } from '@/hooks/useWhoami'
import PATHS from '@/routes/paths'

/**
 * @param {{ children: import('react').ReactNode }} props
 */
export default function Unprotected({ children }) {
  const whoami = useWhoami()

  if (!isAuthEnforced()) {
    return children
  }

  const authenticated =
    isAuthDevBypass() || isWhoamiAuthenticated(whoami) || Boolean(getAccessToken())

  if (authenticated && !whoami.isLoading) {
    return <Navigate to={PATHS.HOME} replace />
  }

  return children
}
